module.exports = __webpack_public_path__ + "static/media/dangerIcon.0e23ff3e.svg";